import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { getApiErrorMessage } from '@/error-handler/api-error-messages/ApiErrorMessages';
import { ApiError } from '@/error-handler/ApiError';
import useCrossWindowState from '@/hooks/domain/useCrossWindowState';
import LoadingLayout from '@/layouts/LoadingLayout';
import services from '@/services/index';

export type SlackWebhookResponse = {
  success: boolean;
  error_msg?: string;
};

const SlackWebhookRedirect = () => {
  const [, setRedirect] = useCrossWindowState<SlackWebhookResponse | null>(
    'slack-webhook-redirect',
    null,
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const workspaceAlias = state;
      const asyncUpdateHandler = async () => {
        try {
          await services.slackWebhook.createSlackWebhookInfo(
            code,
            workspaceAlias,
          );
          setRedirect({
            success: true,
          });
          window.close();
        } catch (e) {
          if (e instanceof ApiError) {
            setRedirect({
              success: false,
              error_msg: getApiErrorMessage(e.data.client_code),
            });
            window.close();
          } else {
            navigate('/500', { replace: true });
          }
        }
      };
      asyncUpdateHandler();
    }
  }, [setRedirect, navigate, searchParams]);

  return <LoadingLayout>Connecting this slack channel...</LoadingLayout>;
};

export default SlackWebhookRedirect;
